export const auswanderung_data = [
  {
    name: 'Mitte',
    bewegung: 'Zuzüge',
    _2022: 36870,
    _2023: 27679,
  },
  {
    name: 'Mitte',
    bewegung: 'Fortzüge',
    _2022: 21341,
    _2023: 20534,
  },
  {
    name: 'Mitte',
    bewegung: 'Saldo',
    _2022: 15529,
    _2023: 7145,
  },
  {
    name: 'Friedrichshain-Kreuzberg',
    bewegung: 'Zuzüge',
    _2022: 22202,
    _2023: 17507,
  },
  {
    name: 'Friedrichshain-Kreuzberg',
    bewegung: 'Fortzüge',
    _2022: 15203,
    _2023: 14512,
  },
  {
    name: 'Friedrichshain-Kreuzberg',
    bewegung: 'Saldo',
    _2022: 6999,
    _2023: 2995,
  },
  {
    name: 'Pankow',
    bewegung: 'Zuzüge',
    _2022: 23480,
    _2023: 18909,
  },
  {
    name: 'Pankow',
    bewegung: 'Fortzüge',
    _2022: 18006,
    _2023: 17762,
  },
  {
    name: 'Pankow',
    bewegung: 'Saldo',
    _2022: 5474,
    _2023: 1147,
  },
  {
    name: 'Charlottenburg-Wilmersdorf',
    bewegung: 'Zuzüge',
    _2022: 28183,
    _2023: 21228,
  },
  {
    name: 'Charlottenburg-Wilmersdorf',
    bewegung: 'Fortzüge',
    _2022: 18550,
    _2023: 16385,
  },
  {
    name: 'Charlottenburg-Wilmersdorf',
    bewegung: 'Saldo',
    _2022: 9633,
    _2023: 4843,
  },
  {
    name: 'Spandau',
    bewegung: 'Zuzüge',
    _2022: 14041,
    _2023: 11285,
  },
  {
    name: 'Spandau',
    bewegung: 'Fortzüge',
    _2022: 9336,
    _2023: 9953,
  },
  {
    name: 'Spandau',
    bewegung: 'Saldo',
    _2022: 4705,
    _2023: 1332,
  },
  {
    name: 'Steglitz-Zehlendorf',
    bewegung: 'Zuzüge',
    _2022: 16046,
    _2023: 11711,
  },
  {
    name: 'Steglitz-Zehlendorf',
    bewegung: 'Fortzüge',
    _2022: 12543,
    _2023: 11673,
  },
  {
    name: 'Steglitz-Zehlendorf',
    bewegung: 'Saldo',
    _2022: 3503,
    _2023: 38,
  },
  {
    name: 'Tempelhof-Schöneberg',
    bewegung: 'Zuzüge',
    _2022: 19594,
    _2023: 15889,
  },
  {
    name: 'Tempelhof-Schöneberg',
    bewegung: 'Fortzüge',
    _2022: 14297,
    _2023: 13904,
  },
  {
    name: 'Tempelhof-Schöneberg',
    bewegung: 'Saldo',
    _2022: 5297,
    _2023: 1985,
  },
  {
    name: 'Neukölln',
    bewegung: 'Zuzüge',
    _2022: 16000,
    _2023: 14489,
  },
  {
    name: 'Neukölln',
    bewegung: 'Fortzüge',
    _2022: 12143,
    _2023: 12700,
  },
  {
    name: 'Neukölln',
    bewegung: 'Saldo',
    _2022: 3857,
    _2023: 1789,
  },
  {
    name: 'Treptow-Köpenick',
    bewegung: 'Zuzüge',
    _2022: 15345,
    _2023: 12788,
  },
  {
    name: 'Treptow-Köpenick',
    bewegung: 'Fortzüge',
    _2022: 10947,
    _2023: 11798,
  },
  {
    name: 'Treptow-Köpenick',
    bewegung: 'Saldo',
    _2022: 4398,
    _2023: 990,
  },
  {
    name: 'Marzahn-Hellersdorf',
    bewegung: 'Zuzüge',
    _2022: 12844,
    _2023: 10380,
  },
  {
    name: 'Marzahn-Hellersdorf',
    bewegung: 'Fortzüge',
    _2022: 9347,
    _2023: 9746,
  },
  {
    name: 'Marzahn-Hellersdorf',
    bewegung: 'Saldo',
    _2022: 3497,
    _2023: 634,
  },
  {
    name: 'Lichtenberg',
    bewegung: 'Zuzüge',
    _2022: 16498,
    _2023: 13315,
  },
  {
    name: 'Lichtenberg',
    bewegung: 'Fortzüge',
    _2022: 12277,
    _2023: 12888,
  },
  {
    name: 'Lichtenberg',
    bewegung: 'Saldo',
    _2022: 4221,
    _2023: 427,
  },
  {
    name: 'Reinickendorf',
    bewegung: 'Zuzüge',
    _2022: 19717,
    _2023: 20525,
  },
  {
    name: 'Reinickendorf',
    bewegung: 'Fortzüge',
    _2022: 10830,
    _2023: 9976,
  },
  {
    name: 'Reinickendorf',
    bewegung: 'Saldo',
    _2022: 8887,
    _2023: 10549,
  },
  {
    name: 'Berlin',
    bewegung: 'Zuzüge',
    _2022: 240820,
    _2023: 195705,
  },
  {
    name: 'Berlin',
    bewegung: 'Fortzüge',
    _2022: 164820,
    _2023: 161831,
  },
  {
    name: 'Berlin',
    bewegung: 'Saldo',
    _2022: 76000,
    _2023: 33874,
  },
]
